// export const  DEV = 'https://hotel.rinconclub.com.ar/api/'
// export const AUTH = 'https://rincon-club.tk/'

//export const API = 'https://unpocomasindumentaria.com/api'
//export const MP = 'https://unpocomasindumentaria.com'

export const API = 'api'
export const MP = ''


let http_headers2 = {
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/json',
    'authorization': 'xxx'
}

const cifrado = "zXYuvGjkMq".split("")
const base = 7*19*23*23

// 689
export const getUrl = (pidNro) => {
  return ((parseInt(pidNro)+base).toString().split("").map( v => cifrado[v]).join(""))
}

// kXzvY
export const getPid = (pidUrl) => {
  return parseInt(pidUrl.split("").map( v => cifrado.indexOf(v) ).join(""))-base
}

export const getToken = async() => {
    const res = await fetch(`${API}/token`,{
          method:'POST',
          headers: http_headers2
      })
      if(res.ok){
          const data = await res.json()
          return {ok:true, data:data.data, token:data.token} //, fields: Object.keys(data.data[0])}
      }else{
          return {ok:false, data:[], token:''}
      }
}


export const  execLogin = async (data) => {
    let params = data.params
    let headers = http_headers2
    // headers.authorization = 'Bearer '+JSON.parse(localStorage.getItem("AUTH_RINCON")).token
      const res = await fetch(`${API}/login`,{
          method:'POST',
          headers: headers,
          body: JSON.stringify(params)
      })
      if(res.ok){
          const data = await res.json()
          return {ok:true, data:data.data, token:data.token} //, fields: Object.keys(data.data[0])}
      }else{
          return {ok:false, data:[], token:''}
      }
}


export const  execCheckEmail00 = async (data) => {
    let email = (data.params?.email || '').trim()
    let query = `select * from usuarios where email = "${email}" and activo=1`
    let headers = http_headers2
    headers.authorization = 'Bearer '+JSON.parse(localStorage.getItem("UPM_AUTH")).token
      const res = await fetch(`${API}/query`,{
          method:'POST',
          headers: headers,
          body: JSON.stringify({query})
      })
      if(res.ok){
          const data = await res.json() || {}
          if(data.data[0].length === 1){
            return {ok:true, data:[], token:''}
            /*
            //el email existe , pido codigo de acceso mayorista
            return {ok:true,data:data.data[0],token:data.token}
            */
          }else{
            return {ok:false, data:[], token:''}
            // creo nuevo usuario
            /*
            let newId = await altaUsuario(params.email)
            let newUser = await getUsuario(newId)
            return {ok:true, data:newUser, token:data.token} //, fields: Object.keys(data.data[0])}
            */
          }
      }else{
          //return {ok:false, data:[], token:''}
          return {ok:false, data:[], token:''}
      }
}

export const  execCheckEmail = async (data) => {
    let email = data.params.email
    let query = `select * from usuarios where email = "${email}" and activo=1`
    let headers = http_headers2
    headers.authorization = 'Bearer '+JSON.parse(localStorage.getItem("UPM_AUTH")).token
      const res = await fetch(`${API}/query`,{
          method:'POST',
          headers: headers,
          body: JSON.stringify({query})
      })
      if(res.ok){
          const data = await res.json() || {}
          if(data.data[0].length === 1){
            return {ok:true, data:[], token:''}
          }else{
            return {ok:false, data:[], token:''}
          }
      }else{
          return {ok:false, data:[], token:''}
      }
}


export const  execCheckClave = async (data) => {
    let email = data.params.email
    let clave = data.params.clave
    let query = `select * from usuarios where email = "${email}" and activo=1`
    let headers = http_headers2
    headers.authorization = 'Bearer '+JSON.parse(localStorage.getItem("UPM_AUTH")).token
      const res = await fetch(`${API}/query`,{
          method:'POST',
          headers: headers,
          body: JSON.stringify({query})
      })
      if(res.ok){
          const data = await res.json()
          if(data.data[0].length === 1){
            return {ok:true,data:data.data[0],token:data.token}
          }else{
            return {ok:false, data:[], token:''}
          }
      }else{
          return {ok:false, data:[], token:''}
      }
}

export const  execNewUser = async (data) => {
    let email = data.params.email
    let clave = data.params.clave

    let newId = await altaUsuario(email,clave)
    let newUser = await getUsuario(newId)
    return {ok:true, data:newUser, token:data.token}
}



export const  execQuery = async (data) => {
    let query = data.query
    let params = data.params
    let headers = http_headers2
    
    headers.authorization = 'Bearer '+JSON.parse(localStorage.getItem("UPM_AUTH")).token
      const res = await fetch(`${API}/query`,{
          method:'POST',
          headers: headers,
          body: JSON.stringify({query})
      })
      if(res.ok){
          const data = await res.json()
          return {ok:true, data:data.data} //, fields: Object.keys(data.data[0])}
      }else{
          return {ok:false, data:[]}
      }
}

export const execMutation = async (data) => {

  let mutationData = {
    tabname: data.tabname, 
    mutation: data.mutation,
    mutationId: data.mutationId,
    params: data.params
  }

  // get token
  let headers = http_headers2
  //headers.authorization = 'Bearer '+JSON.parse(localStorage.getItem("rincon_data"))[1].token
  headers.authorization = 'Bearer '+JSON.parse(localStorage.getItem("UPM_AUTH")).token
  const res = await fetch(`${API}/mutation`,{
    method:'POST',
    headers: headers,
    body: JSON.stringify(mutationData)
  })
  if(res.ok){
    const data = await res.json()
    return  data
  }else{
    return 
  }
}

export const execRawMutation = async (stmt) => {
  let headers = http_headers2
  headers.authorization = 'Bearer '+JSON.parse(localStorage.getItem("UPM_AUTH")).token
  const res = await fetch(`${API}/raw_mutation`,{
    method:'POST',
    headers: headers,
    body: JSON.stringify({stmt})
  })
  if(res.ok){
    const data = await res.json()
    return  data
  }else{
    return 
  }   
}

export const execMercadoPago = async (payment) => {
  let headers = http_headers2
  let urlParams = Object.keys(payment).map(key => key + '=' + payment[key]).join('&')
  
  headers.authorization = 'Bearer '+JSON.parse(localStorage.getItem("UPM_AUTH")).token
  const res = await fetch(`${MP}/mp?${urlParams}`,{
    method:'GET',
    headers: headers,
    //body: JSON.stringify({payment})
  })
  if(res.ok){
    const data = await res.json()
    return  data
  }else{
    return ''
  }   
}


export const uploadImg = async (fd,n,f) => {
    let headers = { 
      'Accept': 'application/json, text/plain, */*',
      'authorization' : 'Bearer '+JSON.parse(localStorage.getItem("UPM_AUTH")).token,
      //'Content-Type': 'multipart/form-data'
    }
   // console.log(fd)
    const res = await fetch(`${API}/upload?n=${n}&f=${f}`, {
          method: 'POST',
          headers: headers,
          body: fd
        })
    
    if (res.ok) {
      return true
    } else {
      return false
      //throw new Error("file upload error");
    }   
  }

export const  execCheckStock = async (data) => {
    let prd = data.idproducto
    let subprd = data.subproducto
    let size = data.size

    let query = `select (qtty-qttysold) as dispo from stock where idproducto=${prd} and subproducto='${subprd}' and size='${size}'`
    let headers = http_headers2
    headers.authorization = 'Bearer '+JSON.parse(localStorage.getItem("UPM_AUTH")).token
      const res = await fetch(`${API}/query`,{
          method:'POST',
          headers: headers,
          body: JSON.stringify({query})
      })
      if(res.ok){
          const data = await res.json() || {}
          //console.log(data)
          return { dispo : data.data[0][0]?.dispo || 0 }
      }else{
          return { dispo : 0 }
      }
}


  const altaUsuario = async (email,clave) => {
      let mutationData = {
        tabname: 'usuarios', 
        mutation: 'insert',
        mutationId: 'id',
        params: {email:email, clave:clave, tipo:'MINO'}
      }

      // get token
      let headers = http_headers2
      headers.authorization = 'Bearer '+JSON.parse(localStorage.getItem("UPM_AUTH")).token
      const res = await fetch(`${API}/mutation`,{
        method:'POST',
        headers: headers,
        body: JSON.stringify(mutationData)
      })
      if(res.ok){
        const data = await res.json()
        return  data.data[0]
      }else{
        return 0
      }

  }

  const getUsuario = async (id) => {
      let query = `select * from usuarios where id = ${id}`
      let headers = http_headers2
      headers.authorization = 'Bearer '+JSON.parse(localStorage.getItem("UPM_AUTH")).token
        const res = await fetch(`${API}/query`,{
            method:'POST',
            headers: headers,
            body: JSON.stringify({query})
        })
        if(res.ok){
            const data = await res.json()
            return data.data[0]
        }else{
          return {}
        }
  }


